export const DeviceIndexSceneTranslation = {
  fi: {
    DeviceIndexScene: {
      title: 'Älylääkevaunut',
      create: 'Yhdistä uusi',
      emptyText: 'Voit yhdistää uuden älylääkevaunun sivun oikeasta ylälaidasta.',
    },
  },
};
